import React, { useEffect } from "react";
import { ENV_LISTS } from "../../core/EnvTranspiler";

interface TokenRefreshContextProps {}

const tokenRefreshContextDefault: TokenRefreshContextProps = {};

export const TokenRefreshStateContext =
  React.createContext<TokenRefreshContextProps>(tokenRefreshContextDefault);

const TokenRefreshContextFC: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  useEffect(() => {
    const tempExpireTimeRaw = localStorage.getItem(ENV_LISTS.EXP_TOKEN);
    if (tempExpireTimeRaw) {
      const tempExpireTime = JSON.parse(tempExpireTimeRaw);
      const targetDate = new Date(tempExpireTime);
      const currentDate = new Date();
      if (currentDate > targetDate) {
        localStorage.clear();
        window.location.reload();
      }
    }
  }, []);

  return (
    <TokenRefreshStateContext.Provider value={{}}>
      {children}
    </TokenRefreshStateContext.Provider>
  );
};

export const useTokenRefresh = () => React.useContext(TokenRefreshStateContext);

export default TokenRefreshContextFC;
